// Code taken from https://github.com/nextauthjs/next-auth/blob/main/packages/next-auth/src/client/_utils.ts#L80
/**
 * Inspired by [Broadcast Channel API](https://developer.mozilla.org/en-US/docs/Web/API/Broadcast_Channel_API)
 * Only not using it directly, because Safari does not support it.
 *
 * https://caniuse.com/?search=broadcastchannel
 */
export class BroadcastChannel {
    constructor(name) {
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: name
        });
    }
    set onmessage(value) {
        this.receive(value);
    }
    /** Get notified by other tabs/windows. */
    receive(onReceive) {
        const handler = (event) => {
            var _a;
            if (event.key !== this.name) {
                return;
            }
            const message = JSON.parse((_a = event.newValue) !== null && _a !== void 0 ? _a : '{}');
            if (!(message === null || message === void 0 ? void 0 : message.data)) {
                return;
            }
            onReceive(message);
        };
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }
}
